import { useState } from 'react';
import { createPortal } from 'react-dom';
import clx from 'classnames';
import style from './Badgets.module.scss';

const SmallBadge = ({ icon, text, iconSizeSmall, hover, compact }) => {
  const [coords, setCoords] = useState(null);
  const label = text == null || text === false ? '' : String(text);

  const showTooltip = (event) => {
    if (!hover || !label) return;
    const rect = event.currentTarget.getBoundingClientRect();
    setCoords({
      top: rect.top,
      left: rect.left + rect.width / 2,
    });
  };

  const hideTooltip = () => setCoords(null);

  return (
    <div
      className={clx(style.badget_small, { [style.badget_small_compact]: compact })}
      draggable={false}
      onPointerEnter={showTooltip}
      onPointerLeave={hideTooltip}
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
      onMouseDown={(event) => event.stopPropagation()}
      onDragStart={(event) => {
        event.preventDefault();
        event.stopPropagation();
      }}
    >
      <div
        className={style.badget_small_icon}
        style={{
          maxWidth: iconSizeSmall,
          maxHeight: iconSizeSmall,
          minWidth: iconSizeSmall,
          minHeight: iconSizeSmall,
        }}
      >
        {icon}
      </div>
      {coords
        ? createPortal(
            <div
              className={style.info_card_portal}
              style={{
                top: coords.top - 8,
                left: coords.left,
              }}
            >
              {label}
            </div>,
            document.body,
          )
        : null}
    </div>
  );
};

export const Badgets = ({
  icon,
  text,
  type = 'Small',
  iconSizeSmall = '24px',
  iconSize = '30px',
  hover = false,
  compact = false,
}) => {
  if (type === 'Large') {
    return (
      <div className={style.badget}>
        <div
          className={style.badget_icon}
          style={{
            maxWidth: iconSize,
            maxHeight: iconSize,
            minWidth: iconSize,
            minHeight: iconSize,
          }}
        >
          {icon}
        </div>
        <div className={style.badget_text}>{text}</div>
      </div>
    );
  }

  return (
    <SmallBadge
      icon={icon}
      text={text}
      iconSizeSmall={iconSizeSmall}
      hover={hover}
      compact={compact}
    />
  );
};
